import React from 'react'
import { useTranslation } from 'react-i18next'
import TextInput from 'components/ui/forms/field/text-input/TextInput'
import TextAreaInput from 'components/ui/forms/field/text-area/TextArea'
import { IBlockInstanceModel } from 'models/block.model'
import styles from './SurveyDetails.module.scss'

interface ISurveyDetails {
  values: IBlockInstanceModel
  onChange: (values: IBlockInstanceModel) => void
  errors: Record<string, string>
}

/** Name and description of a survey. The editor shell draws Cancel and Next. */
const SurveyDetails: React.FC<ISurveyDetails> = ({
  onChange,
  values,
  errors,
}) => {
  const { t } = useTranslation()
  return (
    <div className={'d-flex flex-column'}>
      <h1 className={`mb-2 ${styles.title}`}>
        {t('administration.surveyEditor.surveyDetails')}
      </h1>
      <div className={'w-50 mb-4'}>
        <TextInput
          name={'name'}
          placeHolder=""
          label={t('administration.surveyEditor.title')}
          value={values['name']}
          onChange={(e) => onChange({ ...values, name: e.target.value })}
          error={errors['name']}
        />
      </div>
      <div className={'w-100 mb-5'}>
        <TextAreaInput
          name={'description'}
          rows={3}
          label={t('administration.surveyEditor.description')}
          value={values['description']}
          onChange={(e) => onChange({ ...values, description: e.target.value })}
          error={errors['description']}
        />
      </div>
    </div>
  )
}

export default SurveyDetails
